import React, {useEffect, useState} from 'react'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import Kp11GenericCardNumberInput from '../kp-11-generic-cards/kp11-generic-card-number-input'
import {normalizeQuantity} from '../../../../kp-11Link-utility/kp11-utility'

const KP11KeapCustomDoneForYou = ({
  name,
  price,
  isChecked,
  groupKey,
  itemCode,
  onSave,
  quantity,
  billingType,
  selectedCountry,
}) => {
  const [value, setValue] = useState(String(normalizeQuantity(quantity)))
  const [isExpanded, setIsExpanded] = useState(isChecked)

  useEffect(() => {
    setValue(String(normalizeQuantity(quantity)))
  }, [quantity])

  useEffect(() => {
    setIsExpanded(isChecked)
  }, [isChecked])

  const handleChange = newValue => {
    setValue(newValue)
  }

  return (
    <Kp11GenericCardNumberInput
      name={name || 'Custom Done For You'}
      price={price}
      billingType={billingType}
      isChecked={isExpanded}
      onClick={() => setIsExpanded(true)}
      label="Please enter a number between 1 and 1000:"
      value={value}
      onChange={handleChange}
      min={1}
      max={1000}
      groupKey={groupKey}
      itemCode={itemCode}
      onSave={finalValue => onSave?.(finalValue)}
      existingquantity={Number(quantity) || 0}
      quantityValidationRequired={true}
      selectedCountry={selectedCountry}
    />
  )
}

export default KP11KeapCustomDoneForYou
